import { render, staticRenderFns } from "./UnverifiedUserAlert.vue?vue&type=template&id=1972841e"
import script from "./UnverifiedUserAlert.vue?vue&type=script&lang=js"
export * from "./UnverifiedUserAlert.vue?vue&type=script&lang=js"
import style0 from "./UnverifiedUserAlert.vue?vue&type=style&index=0&id=1972841e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports